import ArticleCollectionLayout from "./ArticleCollectionLayout";
import ArticlesContainer from "core-web/containers/ArticlesContainer";
import CmsModules from "theme/libs/wordpress/content/CmsModules";
import PageWrapper from "theme/components/wrappers/PageWrapper";
import PropTypes from "prop-types";
import { isEmpty } from "core-web/utils/object";
import useSaveResponse from "core-web/hooks/useSaveResponse";
import { useTranslation } from "react-i18next";

const ArticleCollection = ({ data }) => {
    const { t } = useTranslation();
    const [savedResponse, saveResponse] = useSaveResponse();
    const { hero_content: heroContent, title } = data;

    const breadcrumbs = [{ permalink: "/", title: t("breadcrumbs.home") }];

    breadcrumbs.push({ permalink: null, title });

    return (
        <PageWrapper>
            <CmsModules
                data={
                    heroContent && Array.isArray(heroContent) && heroContent.length > 0
                        ? heroContent[0]
                        : { layout: "page_intro_module", data: {} }
                }
                breadcrumbs={breadcrumbs}
            />
            <ArticlesContainer
                firstPageSize={13}
                pageSize={12}
                render={({ response }) => {
                    saveResponse(response);
                    if (!isEmpty(savedResponse.current)) {
                        return <ArticleCollectionLayout response={savedResponse.current} />;
                    }
                    return null;
                }}
            />
        </PageWrapper>
    );
};

ArticleCollection.propTypes = {
    data: PropTypes.shape({
        hero_content: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
        title: PropTypes.string,
    }).isRequired,
};

export default ArticleCollection;
